import {
  headTitleList1,
  headTitleList2,
  headTitleList3,
  headTitleList4,
} from "./parts";
import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../context/globalContext";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CommonOrCommonRetirementFlug,
  FormClassApply,
  formClassFacility,
  FormKbn,
  InquiryCode,
  Prefectures,
  YesOrNoFlug,
} from "../../assets/data/Constants";
import { TkGetCode } from "../../utils/TkGetCode";
import { Box, Typography } from "@mui/material";
import TkBackButton from "../../components/molecules/TkBackButton";
import { BusinessContext } from "../../context/businessContext";
import TkTable from "../../components/atoms/TkTable";
import { httpIAPI_APP003, httpIAPI_APP016 } from "./api/request";
import { IAPI_APP016_Request } from "../../type/apiType";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import TkButton from "../../components/atoms/TkButton";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import TkMemo from "../../components/molecules/TkMemo";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import {
  changeZipcodeFormat,
  isStatusAfterApproval,
} from "../../utils/useTools";

/**
 * SCRW070003 申請情報詳細（新設届）
 * @returns JSX.Element
 */
const SCRW070003 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location.state;
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);

  // 基本情報
  const [bodyList1, setBodyList1] = useState([]);

  // 「特定介護保険施設等」又は「申出施設等」に該当する申込施設の付加情報
  const [bodyList2, setBodyList2] = useState([]);

  // 職員数情報
  const [bodyList3, setBodyList3] = useState([]);
  const [bodyList4, setBodyList4] = useState([]);
  const [status, setStatus] = useState<any>();
  const [memoData, setMemoData] = useState("");
  const [memoCheck, setMemoCheck] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [bodyListData, setBodyListData] = useState([]);
  const httpReqIApplicationStatusUpdateRequest: any = {};
  const [corpApplyKbn, setCorpApplyKbn] = useState<any>();
  const nameData =
    (businessState.common?.contractorNo ?? "") +
    ":" +
    (businessState?.common?.contractorName ?? "");

  // 申請ID
  const applyId = locationState?.applyId ?? businessState.job_15?.applyId;
  const hasGroupAppyId = businessState.groupApply?.applyId;

  const handleInit = async () => {
    try {
      const res = await httpIAPI_APP003({ applyId });

      if (res.resultCd === "I0000") {
        setStatus(res.latestApplyStatus);
        setCorpApplyKbn(res.corpApplyKbn);

        // 基本情報データの設置
        let data1: any = [];
        res.applyFacilityInfoList?.forEach((item) => {
          let documentaryEvidence = res.fileList?.find(
            (file) =>
              file.formKbn === FormKbn["施設書類"] &&
              file.formClass ===
                formClassFacility["当該施設・事業を経営している証拠書類"] &&
              file.facilityNo === item.facilityNo
          );

          const itemData = [
            {
              children: item.applyDate,
              align: "center",
            },
            {
              children: (
                <Box>
                  <Typography>
                    {(item.facilityNo ?? "") + ":" + (item.facilityName ?? "")}
                  </Typography>
                  <Typography>{changeZipcodeFormat(item.zipcode)}</Typography>
                  {item.addressOthers! === null ? (
                    <Typography>
                      {(TkGetCode(Prefectures, item?.prefecture!) ?? "") +
                        (item.addressCity! ?? "")}
                    </Typography>
                  ) : (
                    <Typography>
                      {(TkGetCode(Prefectures, item?.prefecture!) ?? "") +
                        (item.addressCity! ?? "") +
                        (item.addressOthers! ?? "")}
                    </Typography>
                  )}
                </Box>
              ),
            },
            {
              children: item.facilityKind,
            },
            {
              children: item.facilityKbn,
            },
            {
              children: documentaryEvidence ? (
                <TkDownloadLink
                  dataname={documentaryEvidence?.fileName ?? ""}
                  base64filedata={documentaryEvidence?.fileBase64 ?? ""}
                  downloadBase64
                />
              ) : null,
            },
          ];
          data1.push(itemData);
        });
        setBodyList1(data1);
        // 「特定介護保険施設等」又は「申出施設等」に該当する申込施設の付加情報データの設置
        let data2: any = [];
        const fileList = res.fileList?.filter(
          (itemFile) =>
            itemFile.formClass === "RPT0203025" ||
            itemFile.formClass === "RPT0203026"
        );
        res.applyFacilityAddInfoList?.forEach((item) => {
          let uniqueFacilityNo: any[] = [];
          const seenFacilityKbn = new Set();

          for (const item of res?.applyFacilityInfoList!) {
            if (!seenFacilityKbn.has(item.facilityKbn)) {
              uniqueFacilityNo.push({
                facilityNo: item.facilityNo,
                facilityKbn: item.facilityKbn,
              });
              seenFacilityKbn.add(item.facilityKbn);
            }
          }
          uniqueFacilityNo = uniqueFacilityNo?.filter?.(
            (u) => u.facilityNo === item.facilityNo
          );
          const itemData = [
            {
              children:
                (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""),
            },
            {
              children: TkGetCode(YesOrNoFlug, item.salaryPaymentDelayFlg),
              align: "center",
            },
            {
              children: TkGetCode(YesOrNoFlug, item.hadContractFlg),
              align: "center",
            },
            {
              children: item.pastContractCancelDate,
              align: "center",
            },
            {
              children: fileList
                ?.filter?.((file) => {
                  if (
                    file.formClass === "RPT0203025" &&
                    uniqueFacilityNo?.[0]?.facilityKbn === "特定介護保険施設等"
                  ) {
                    return true;
                  } else {
                    return (
                      file.formClass === "RPT0203026" &&
                      uniqueFacilityNo?.[0]?.facilityKbn === "申出施設等"
                    );
                  }
                })
                ?.map((itemFile, index) => {
                  return (
                    <span className="tkdownloadlink">
                      <TkDownloadLink
                        key={index}
                        isButton
                        base64filedata={itemFile.fileBase64!}
                        buttonName={"ダウンロード"}
                        dataname={TkGetCode(
                          FormClassApply,
                          itemFile?.formClass
                        )}
                        downloadBase64={true}
                      ></TkDownloadLink>
                    </span>
                  );
                }),
            },
          ];
          data2.push(itemData);
        });

        setBodyList2(data2);

        // 職員数情報
        let data3: any = [];
        res.staffNumInfoList?.forEach((item) => {
          const itemData = [
            {
              children: item.facilityKind,
            },
            {
              children:
                (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""),
            },
            {
              children: item.admissionCapacityNum,
              align: "right",
            },
            {
              children: item.staffBaseNum,
              align: "right",
            },
            {
              children: (
                <Box className="infoBtn">
                  <TkButton onClick={() => handleClick(item)}>
                    職員情報参照
                  </TkButton>
                </Box>
              ),
            },
          ];
          data3.push(itemData);
        });
        setBodyList3(data3);

        // 処理状況リスト設置
        let data4: any = [];
        res.statusList?.forEach((item) => {
          const itemData = [
            {
              children: item.managerName,
            },
            {
              children: item.process,
            },
            {
              children: item.createDate,
              align: "center",
            },
            {
              children: item.processComment,
            },
          ];
          data4.push(itemData);
        });
        setBodyListData(data4);

        const isBodylist4Visible = isStatusAfterApproval(res.latestApplyStatus);
        let file = res.fileList?.find(
          (item) => item.formClass === "EXP0201007"
        );
        const bodyList4: any = [
          [
            {
              children: file && (
                <TkDownloadLink
                  base64filedata={file?.fileBase64!}
                  dataname={
                    TkGetCode(FormClassApply, "EXP0201007") +
                    "・" +
                    TkGetCode(FormClassApply, "EXP0201008")
                  }
                  downloadBase64
                />
              ),
              width: "50%",
            },
            {
              children: isBodylist4Visible && res.symbolNo,
            },
            {
              children: isBodylist4Visible && res.decisionDate,
            },
          ],
        ];

        setBodyList4(bodyList4);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 職員情報参照ボタン押す
  const handleClick = (item: any) => {
    setBusinessState({
      ...businessState,
      job_15: {
        ...businessState?.job_15,
        applyId: applyId,
      },
    });

    navigate("/SCRW070002", {
      state: {
        ...locationState,
        applyId,
        contractorNo: businessState.common?.contractorNo,
        contractorName: businessState.common?.contractorName,
        facilityKind: item.facilityKind,
        facilityNo: item.facilityNo,
        facilityName: item.facilityName,
      },
    });
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const makeHttpObj = (data: IAPI_APP016_Request, num: any, formData?: any) => {
    if (num !== "9") {
      data.applyEvent = num;
    }

    data.reason = memoData;
    data.applyId = applyId;
    data.contractorNo = businessState.common?.contractorNo;
    data.screenId = "SCRW070003";
    if (memoCheck) {
      data.inquiryCode = InquiryCode["施設"];
    }
    if (formData?.symbolNumber) {
      data.symbolNo =
        TkGetCode(CommonOrCommonRetirementFlug, formData.symbolNumberType) +
        "第" +
        formData.symbolNumber +
        "号";
      data.decisionDate = formData.settlementDate;
    }
    return data;
  };

  const handleBtnClick = async (btnName: any) => {
    const num =
      btnName === "拒絶通知"
        ? "10"
        : btnName === "郵送"
        ? "11"
        : btnName === "契約者に差戻し"
        ? "5"
        : btnName === "受理"
        ? "2"
        : btnName === "承認"
        ? "3"
        : btnName === "担当者に差戻し"
        ? "8"
        : btnName === "課長代理確認"
        ? "14"
        : btnName === "上長承認"
        ? "6"
        : btnName === "通知"
        ? "9"
        : btnName === "拒絶"
        ? "4"
        : btnName === "課長代理拒絶確認"
        ? "15"
        : btnName === "上長拒絶承認"
        ? "7"
        : null;
    if (num === "3") {
      setIsOpen(true);
      return;
    }
    if (num === null) {
      return;
    }

    if (num === "9") {
      navigate("/SCRW130001", {
        state: {
          ...locationState,
          applyId,
          contractorNo: businessState.common?.contractorNo,
          refInquiryScreen: memoCheck ? InquiryCode["施設"] : undefined,
          screenId: "SCRW070003",
          memo: memoData ?? undefined,
        },
      });
      return;
    }
    let reqData: IAPI_APP016_Request = makeHttpObj(
      httpReqIApplicationStatusUpdateRequest,
      num
    );

    try {
      const res = await httpIAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onChange = (event: any) => {
    switch (event.target.type) {
      case "input":
        setMemoData(event.target.value);
        break;
      case "checkbox":
        setMemoCheck(event.target.value);
        break;
    }
  };
  const handleSave = async (formData: any) => {
    let reqData: IAPI_APP016_Request = makeHttpObj(
      httpReqIApplicationStatusUpdateRequest,
      "3",
      formData
    );
    try {
      const res = await httpIAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };
  const setOpen = () => {
    setIsOpen(false);
  };
  return (
    <Box className="SCRW070003" data-testid="SCRW070003PageForTest">
      <TkKikoStepper
        applicationFlowType="TYPE1"
        businessType="JOB-15"
        applicationStatus={status}
        corporateApplicationClassification={corpApplyKbn}
      />
      <Box>
        <Box className="info">
          <TkContractorAndNumberLine name={"契約者（法人）名"} no={nameData} />
        </Box>
        <Box className="info">基本情報</Box>
        <TkTable bodyList={bodyList1} headList={headTitleList1} />

        <Box className="info">
          「特定介護保険施設等」又は「申出施設等」に該当する申込施設の付加情報
        </Box>
        <TkTable bodyList={bodyList2} headList={headTitleList2} />

        <Box className="info">職員数情報</Box>
        <TkTable bodyList={bodyList3} headList={headTitleList3} />
      </Box>

      <Box className="info">
        <TkMemo
          bodyList={bodyListData}
          onChange={onChange}
          disabledCheckBox={false}
        />
        <TkTableWithNoLine headList={headTitleList4} bodyList={bodyList4} />
      </Box>
      <TkApprovalDateSymbolNumberRegistrationDialog
        data-testid="SCRW070003PageForDialog"
        open={isOpen}
        onSuccess={handleSave}
        onClose={setOpen}
      />

      <Box className="btnGroup">
        <TkBackButton useBackParam navigateParam={{ applyId }} mr />
        {!hasGroupAppyId && (
          <TkViewButtonJudgement
            flowType="TYPE1"
            Status={status}
            onClick={handleBtnClick}
          />
        )}
      </Box>
    </Box>
  );
};

export default SCRW070003;
